<template>
    <div>
        <p>{{$t("talk_room.no_talk_room")}}</p>
    </div>
</template>
<script>
export default {
    "name": "Empty"
}
</script>